import {
  TPromotionCampaign,
  TPostPromotionCampaign,
  TPatchPromotionCampaign,
  TQueryPromotionCampaign,
  TUpdatePromotionCampaignStatus,
  TPromotionCampaignReport,
} from '@src/modules/promotion-campaign'

import { request } from './config'

// Tạo chiến dịch mới
export const createPromotionCampaign = (body: TPostPromotionCampaign, token: string) =>
  request({ url: 'promotion-campaign', method: 'POST', data: body }, { token })

// Lấy danh sách chiến dịch với phân trang, tìm kiếm, lọc
export const getListPromotionCampaign = (params: TQueryPromotionCampaign, token: string) =>
  request({ url: 'promotion-campaign', method: 'GET', params }, { token })

// Lấy chi tiết chiến dịch
export const getPromotionCampaignById = (id: number, token: string) =>
  request({ url: `promotion-campaign/${id}`, method: 'GET' }, { token })

// Cập nhật chiến dịch (chỉ trạng thái DRAFT)
export const updatePromotionCampaign = (id: number, data: TPatchPromotionCampaign, token: string) =>
  request({ url: `promotion-campaign/${id}`, method: 'PATCH', data }, { token })

// Thay đổi trạng thái chiến dịch
export const updatePromotionCampaignStatus = (
  id: number,
  data: TUpdatePromotionCampaignStatus,
  token: string,
) => request({ url: `promotion-campaign/${id}/status`, method: 'PATCH', data }, { token })

// Xóa chiến dịch (chỉ trạng thái DRAFT)
export const deletePromotionCampaign = (id: number, token: string) =>
  request({ url: `promotion-campaign/${id}`, method: 'DELETE' }, { token })

// Báo cáo chiến dịch
export const getPromotionCampaignReport = (id: number, token: string) =>
  request({ url: `promotion-campaign/${id}/report`, method: 'GET' }, { token })
